<template>
  <div class="user-page">
    <div class="pos t0 header-box zi1">
      <header-df class="user-header g-center" :noTabsActive="true"></header-df>
    </div>
    <offline></offline>
    <div class="content-box por zi0" :class="{'is-remark': $route.name === 'UserRemark'}">
      <div class="user-content flex ova g-center por">
        <div class="user-left por">
          <div class="" :style="leftSize">
            <router-view name="left" class="left-view pof" :class="{'left-bottom': isEnd}" ref="left"/>
          </div>
        </div>
        <div class="user-right flex-1">
          <router-view :key="currView"/>
        </div>
        <div class="poa end-line b0 t0" ref="endLine"></div>
      </div>
    </div>
    <footer-bottom class="footer"></footer-bottom>
  </div>
</template>

<script>
  import Minxis from '../../mixins/mixins';
  import {mapGetters} from 'vuex';

  export default {
    name: "UserIndex",
    mixins: [Minxis.AppScroll(0)],
    computed: {
      ...mapGetters(['userInfo']),
    },
    data() {
      return {
        isEnd: false,
        timer: null,
        leftSize: null,
        bottom: 0,
        currView: 0,
      }
    },
    watch: {
      userInfo(val) {
        val.uid || this.$router.replace('/');
        this.currView++;
      },
      $route(val){
        val.name !== 'UserCollection' && !this.userInfo.uid && this.ToLogin();
      }
    },
    appScroll() {
      this.setEnd();
    },
    mounted() {
      this.$nextTick(this.setLeftSize);
    },
    created() {
      !this.userInfo.uid && this.ToLogin();
    },
    methods: {
      setLeftSize() {
        let {width, height} = this.$refs.left.$el.getBoundingClientRect();
        this.leftSize = {
          width: width + 'px',
          height: height + 'px',
        };
      },
      setEnd() {
        let {endLine, left} = this.$refs;
        if (endLine && left) {
          let {bottom} = endLine.getBoundingClientRect();
          let {bottom: cB} = left.$el.getBoundingClientRect();
          if (!this.isEnd) {
            this.bottom = this.bottom || cB;
          }
          this.isEnd = this.bottom > bottom;
        }
      },
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/less/function";

  /deep/ .mine-ico {
    &.img {
      .spirit(url(../../assets/images/user_icons.png));
    }
    &:not(.img) {
      .spirit-mask(url(../../assets/images/user_icons.png));
    }
    &:after {
      margin-right: 16px;
      width: 22px;
      height: 22px;
      background-color: #959595;
    }
    &.is-vip {
      &:after {
        width: 24px;
        height: 23px;
        mask-position: -50px -2px;
        background-color: #FFC264;
      }
    }
    &.checkbox-df {
      &:after {
        margin: 0;
        width: 19px;
        height: 19px;
        mask-position: -77px -3px;
        background-color: #fff;
      }
    }
    &.checkbox-check {
      &:after {
        margin: 0;
        width: 19px;
        height: 19px;
        mask-position: -99px -3px;
        background-color: #fff;
      }
    }
    &.hover-play {
      &:after {
        margin-right: 0;
        width: 44.3px;
        height: 44.3px;
        mask-position: -52px -30px;
        background-color: #fff;
      }
    }
    &.hover-delete {
      &:after {
        margin-right: 0;
        width: 24px;
        height: 24px;
        background-position: -121px -1px;
      }
    }
    &.lost-time {
      &:after {
        margin-right: 0;
        width: 58px;
        height: 58px;
        background-position: -102px -28px;
      }
    }
    &.tv {
      &:after {
        margin-right: 0;
        width: 104px;
        height: 85px;
        background-position: -229px -2px;
      }
    }
    &.no-follow {
      &:after {
        margin-right: 0;
        width: 104px;
        height: 85px;
        background-position: -340px -2px;
      }
    }
    &.audio {
      &:after {
        margin-right: 0;
        width: 25px;
        height: 25px;
        background-position: -146px -1px;
      }
    }
    &.play {
      &:after {
        mask-position: -3px -2px;
      }
    }
    &.hart {
      &:after {
        margin-right: 0;
        width: 14px;
        height: 14px;
        mask-position: -193.9px -3px;
        background-color: #999;
      }
    }
    &.collection {
      &:after {
        mask-position: -3px -26px;
      }
    }
    &.follow {
      &:after {
        mask-position: -3px -50px;
      }
    }
    &.course {
      &:after {
        mask-position: -3px -74px;
      }
    }
    &.vip {
      &:after {
        mask-position: -3px -98px;
      }
    }
    &.vip1 {
      &:after {
        width: 16px;
        height: 16px;
        mask-position: -170px -55px;
      }
    }
    &.setting {
      &:after {
        mask-position: -3px -122px;
      }
    }
    &.edit-more {
      &:after {
        margin-right: 8px;
        width: 18px;
        height: 18px;
        mask-position: -173px -3px;
      }
    }
    &.change {
      &:after {
        margin-right: 0;
        width: 9px;
        height: 10px;
        background-position: -173px -34px;
      }
    }
    &.exchange-icon {
      &:after {
        width: 56px;
        height: 56px;
        background-position: -58px -95px;
      }
    }
    &.my-vip {
      &:after {
        margin-right: 0;
        width: 104px;
        height: 85px;
        background-position: -229px -89px;
      }
    }
    &.my-record {
      &:after {
        margin-right: 0;
        width: 104px;
        height: 85px;
        background-position: -340px -89px;
      }
    }
    &.arrow-down {
      &:after {
        margin: 0 0 0 4px;
        width: 14px;
        height: 8px;
        mask-position: -190px -34px;
      }
    }

  }

  .header-box {
    background-color: #fff;
  }

  .content-box {
    padding: 48px 0;
    background-color: #f5fcff;
  }

  .user-left {
    margin-right: 16px;
  }

  .left-view {
    top: 112px;
    &.left-bottom {
      position: absolute;
      top: unset;
      bottom: 0;
    }
  }

  .user-right {
    background-color: #fff;
  }

  /deep/ .user-df-title {
    margin-bottom: 24px;
    padding: 16px 0 0 14px;
    font-size: 26px;
    color: #333f4e;
    line-height: 1;
  }

  .is-remark {
    padding: 0;
    .user-content {
      width: unset;
    }
    .user-left {
      display: none;
    }
    .user-right {
      background-color: unset;
    }
  }
</style>